// extracted by mini-css-extract-plugin
export default {"page_layout":"CompleteBooking_page_layout__STRch","confirmation_screen_buttons":"CompleteBooking_confirmation_screen_buttons__rMlj7"};